import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from '@redturtle/volto-io-prenoto/components/Blocks/BookingButton/Sidebar';
import Body from '@redturtle/volto-io-prenoto/components/Blocks/BookingButton/Body';

const Edit = (props) => {
  return (
    <>
      <Body {...props} isEditMode={true} />
      <SidebarPortal selected={props.selected}>
        <Sidebar {...props} />
      </SidebarPortal>
    </>
  );
};

export default Edit;
